import React, { FC, memo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Box } from '@ucheba/ui/components/Box/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { getApiImageUrl } from '@ucheba/utils/helpers/string'
import { IBenefitsItemProps } from '../types'
import { COLORS } from '../constants'
import SC from '../base/InstitutionBenefits.styles'

const { HeadingStyled } = SC

const InstitutionBenefitsItem: FC<IBenefitsItemProps> = ({ data }) => {
  const { content, factType, title } = data
  const { color, iconUrl, title: factTitle } = factType || {}

  return (
    <Box spacing={['small', 'small']} color={color || 'blue'}>
      <Grid nowrap spacing='xxsmall'>
        <GridCol width='auto'>
          {iconUrl && (
            <img
              alt={factTitle}
              style={{ color: COLORS?.[color]?.tag || 'white' }}
              src={getApiImageUrl(iconUrl)}
            />
          )}
        </GridCol>
        <GridCol width='auto'>{factTitle}</GridCol>
      </Grid>

      <HeadingStyled textColor={COLORS?.[color]?.title} h3={title} spacing='usmall' />

      <Text firstLetterUppercase>{content}</Text>
    </Box>
  )
}

export default memo(InstitutionBenefitsItem)
